<template>
  
  <ContentsProductHighPerformancePageTitle title="PPA (Polyphthalamides)" />

  <section class="section-product-detail-page" >
    <div class="container">
      <div class="page-content">

        <div class="properties-applications-box">
          <ContentsTextWithImage
            title="Properties"
            image-url="/pages/products/high-performance-plastics/ppa01.jpg"
            :contents="[
              `PPA is high performance polyamide. It improves polyamides performance such as higher heat resistance (service temp 200c), chemical resistance, strength and stiffness at elevated temperatures, better warpage, dimensional stability, and water absorption.`,
            ]"
            :is-reverse="true"
            left-width="43.444%"
            right-width="56.252%"
          />
  
          <ContentsTextWithImage
            title="Applications"
            image-url="/pages/products/high-performance-plastics/ppa02.jpg"
            :contents="[
              `Automotive under the hood, sport equipment, bearing, valves, connectors, mobile phone, heater, long exposure to harsh environment, bushing, bearing, charge air cooler, metal replacement`,
            ]"
            left-width="43.421%"
            right-width="56.275%"
          />
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page section-our-partners">
    <div class="container">
      <div class="page-content">

        <ContentsOurPartners
          :partners="[
            {
              name: 'Dupont',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/logo-dupon.jpg',
              },
            },
            {
              name: 'DSM',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/logo-dsm.jpg',
              },
            },
            {
              name: 'Solvay',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/psu-logo02.jpg',
              },
            },
            {
              name: 'BASF',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/psu-logo01.jpg',
              },
            },
          ]"
        />

      </div>
    </div>
  </section>

</template>
<script setup lang="ts">
useHead({
  title: 'ppa - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>
.properties-applications-box {
  display: flex;
  flex-direction: column;
  row-gap: 60px;
}

.section-our-partners .page-content {
  padding: 48px 0 60px;
}
</style>